<template>
  <div
    class="multiple-choice-answers"
    :data-test="isSATA ? 'sata-answers' : 'multiple-choice-answers'"
  >
    <div
      v-for="answer in answers"
      :id="`answer-${answer.id}`"
      :key="`answer-${answer.id}`"
      class="multiple-choice-answer"
      :class="{ 'multiple-choice-sata': isSATA }"
      role="checkbox"
      :aria-checked="selected[answer.id]"
      tabindex="0"
      :data-test="`answer-choice-${answer.id}`"
      @click.stop="handleClick(answer.id)"
      @keydown.space.prevent="handleClick(answer.id)"
      @keydown.enter.prevent="handleClick(answer.id)"
    >
      <input
        v-model="selected[answer.id]"
        type="checkbox"
      />
      <label
        class="answer-label"
        :content="answer.content"
        v-html="answer.content"
      ></label>
    </div>
  </div>
</template>

<script>
import MultipleChoiceMixin from '@/mixins/multipleChoice.js';

export default {
  mixins: [MultipleChoiceMixin],
  props: {
    flashcard: {
      type: Object,
      required: true,
    },
    flashcardState: {
      type: Object,
      required: true,
    },
  },
  emits: ['answers-selected'],
  data() {
    return {
      selected: {},
    };
  },
  computed: {
    hasMultipleCorrectAnswers() {
      return this.answers.filter((a) => a.correct).length > 1;
    },
    isSATA() {
      return this.hasMultipleCorrectAnswers || this.flashcard.type === 'SATA';
    },
  },
  watch: {
    flashcardState() {
      this.selected = {};
      this.flashcardState?.answerIds?.forEach( id => {
        this.selected[id] = true;
      });
    },
  },
  mounted() {
    this.selected = {};
    this.flashcardState?.answerIds?.forEach( id => {
      this.selected[id] = true;
    });
  },
  methods: {
    handleClick(answerId) {
      if (this.selected[answerId]) {
        delete this.selected[answerId];
      } else if (!this.isSATA) {
        this.selected = {};
        this.selected[answerId] = true;
      } else {
        this.selected[answerId] = true;
      }
      this.$emit('answers-selected', Object.keys(this.selected).map((id) => parseInt(id, 10)));
    },
  },
};
</script>

<style lang="scss" scoped>

.multiple-choice-answer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border: 1px solid #F4F4F4;
  box-shadow: 0px 2px 6px rgba(224, 224, 224, 0.4), 0px 5px 12px rgba(159, 159, 159, 0.06);
  border-radius: 4px;
  min-height: 3rem;
  font-size: 1rem;
  cursor: pointer;

  .answer-label {
    display: flex;
    cursor: pointer;
    padding-right: 1rem;

    :deep(p) {
      margin-block-start: 0;
      margin-block-end: 0;
    }

    :deep(img) {
      max-height: 20rem;
    }
  }
}

input {
  display: none;

  + label:before {
    height: .8rem;
    width: .8rem;
    min-width: .8rem;
    margin-left: 1.5rem;
    margin-right: 1rem;
    margin-top: 0.2rem;
    content: " ";
    display:inline-block;
    border-radius:50%;
    background-color: white;
    box-shadow: 0 0 0 2px white, 0 0 0 3px black;
  }

  &:checked + label:before {
    background-color: black;
  }
}

.multiple-choice-sata {
  input {
    + label:before {
      border-radius: 1px;
    }
  }
}

.answered-correctly {
  background: #d8e0f3;

  input {
    + label:before {
      background-color: #00B46D;
      box-shadow: 0 0 0 3px #00B46D, 0 0 0 4px #00B46D;
      background-image: url(/src/assets/icons/check-ffffff.svg);
    }
  }
}

.correct-answer {
  input {
    + label:before {
      background-color: #00B46D;
      box-shadow: 0 0 0 3px #00B46D, 0 0 0 4px #00B46D;
      background-image: url(/src/assets/icons/check-ffffff.svg);
    }
  }
}

.answered-incorrectly {
  background: #d8e0f3;

  input {
    + label:before {
      background-color: #DC3416;
      box-shadow: 0 0 0 3px #DC3416, 0 0 0 4px #DC3416;
      background-image: url(/src/assets/icons/cross-ffffff.svg);
    }
  }
}

</style>
